import { NameDto } from 'api/Common/Types'
import { Dispatch } from 'redux'
import { ClientAreaApiClient } from 'utils/api/clientAreaApi'

import { clientAreaSlice } from './clientarea.slice'

export const getNotificationPlatforms = (clientAreaApi: ClientAreaApiClient) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await clientAreaApi.getNotificationPlatforms()
      dispatch(clientAreaSlice.actions.setNotificationPlatforms(response))
    } catch (e) {
      console.error('Error during get notification platforms', e)
    }
  }
}

export const getNotificationProductStatuses = (clientAreaApi: ClientAreaApiClient) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await clientAreaApi.getNotificationProductStatuses()
      dispatch(clientAreaSlice.actions.setNotificationProductStatuses(response))
    } catch (e) {
      console.error('Error during get notification product statuses', e)
    }
  }
}

export const getNotificationAudienceTypes = (clientAreaApi: ClientAreaApiClient) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await clientAreaApi.getNotificationAudienceTypes()
      dispatch(clientAreaSlice.actions.setNotificationAudienceTypes(response))
    } catch (e) {
      console.error('Error during get notifications audience types', e)
    }
  }
}

export const getNotificationTypes = (clientAreaApi: ClientAreaApiClient) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await clientAreaApi.getNotificationTypes()
      dispatch(clientAreaSlice.actions.setNotificationTypes(response))
    } catch (e) {
      console.error('Error during get notifications types', e)
    }
  }
}

export const getNotificationBaseUrlTypes = (clientAreaApi: ClientAreaApiClient) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await clientAreaApi.getNotificationBaseUrlTypes()
      dispatch(clientAreaSlice.actions.setBaseUrlTypes(response))
    } catch (e) {
      console.error('Error during get Base Url Types', e)
    }
  }
}

export const fetchPromoMaterialsOptionsAction = (clientAreaApiClient: ClientAreaApiClient) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await clientAreaApiClient.getPromoMaterialsOptions()
      dispatch(clientAreaSlice.actions.setPromoMaterialsOptions(response))
    } catch (error) {
      console.error('Cannot get client tax availability status', error)
    }
  }
}

export const fetchClientAreaDomain = (clientAreaApiClient: ClientAreaApiClient) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await clientAreaApiClient.getDomains()
      dispatch(clientAreaSlice.actions.setDomain(response))
    } catch (error) {
      console.error('Cannot get domain', error)
    }
  }
}

export const fetchEmailGroupTypes = (clientAreaApiClient: ClientAreaApiClient) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await clientAreaApiClient.getEmailGroupTypes()
      dispatch(clientAreaSlice.actions.setEmailGroupTypes(response))
    } catch (error) {
      console.error('Cannot get email group types', error)
    }
  }
}

export const fetchEmailFromTypes = (clientAreaApiClient: ClientAreaApiClient) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await clientAreaApiClient.getEmailFromTypes()
      dispatch(clientAreaSlice.actions.setEmailFromTypes(response))
    } catch (error) {
      console.error('Cannot get email from types', error)
    }
  }
}

export const fetchReferralMaterialsTypes = (clientAreaApiClient: ClientAreaApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientAreaApiClient.getReferralMaterialsTypes()
      dispatch(clientAreaSlice.actions.setReferralMaterialsTypes(response))
    } catch (e) {
      console.error('Cannot get referral material types', e)
    }
  }
}

export const fetchReferralMaterialsPromoSizes = (clientAreaApiClient: ClientAreaApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientAreaApiClient.getReferralMaterialsPromoSizes()
      dispatch(clientAreaSlice.actions.setReferralMaterialsPromoSizes(response))
    } catch (e) {
      console.error('Cannot get referral material types', e)
    }
  }
}

export const fetchReferralMaterialsPromoContentTypes = (
  clientAreaApiClient: ClientAreaApiClient
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientAreaApiClient.getReferralMaterialsPromoContentTypes()
      dispatch(clientAreaSlice.actions.setReferralMaterialsPromoContentTypes(response))
    } catch (e) {
      console.error('Cannot get referral material types', e)
    }
  }
}

export const fetchReferralMaterialsCategoriesByEntity = (
  clientAreaApiClient: ClientAreaApiClient,
  tickmillCompanyId: number | string,
  isCategoryActive?: boolean
) => {
  return async (dispatch: Dispatch): Promise<(NameDto<string> & { isActive: boolean })[]> => {
    try {
      const response = await clientAreaApiClient.getReferralMaterialsCategoriesByEntity(
        tickmillCompanyId,
        isCategoryActive
      )
      dispatch(clientAreaSlice.actions.setReferralMaterialsCategoriesByEntity(response))

      return response
    } catch (e) {
      console.error('Cannot get referral material types', e)
      return []
    }
  }
}
